import { useCallback } from 'react';

import { useNavigate, useSearch } from '@tanstack/react-router';
import * as z from 'zod';

export const searchParamFilters = z.object({
  per_page: z.number().optional().catch(50),
  page: z.number().optional().catch(1),
  sort: z.string().optional().catch(''),
  search_str: z.string().optional().catch(''),
  filter_str: z.string().optional().catch(''),
});

export type SearchParamFilters = z.infer<typeof searchParamFilters>;

export const useSearchParams = () => {
  const searchParams = useSearch({ strict: false });
  const nav = useNavigate();

  const setSearchParams = useCallback(
    (_params: SearchParamFilters) => {
      const params: SearchParamFilters = {};
      for (const key in _params) {
        const val = _params[key as keyof SearchParamFilters];

        if (!isNaN(Number(val))) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          params[key as keyof SearchParamFilters] = Number(val);
        } else {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          params[key as keyof SearchParamFilters] = val;
        }
      }

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      nav({ search: params });
    },
    [nav]
  );

  return [searchParams, setSearchParams] as const;
};
